import React, { useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import apiCall from "services/apiCall";
import { changeUserOwnPassword, checkUserPasswordReset } from "services/user-service";
import * as Yup from "yup";
import { CustomInput } from "components/Form/CustomInput";
import { useSelector } from "react-redux";
import showToast from "helpers/showToast";
import { getSelectedAuthorization } from "store/slices/userSlice";
import { logout } from "services/auth-service";
import { logout as logoutAction } from "store/slices/userSlice";
import { useDispatch } from "react-redux";

const passwordValidation = Yup.object().shape({
  oldPassword: Yup.string().required("FORM.REQUIRED"),
  password: Yup.string()
    .required("FORM.REQUIRED")
    .min(5, "Yeni şifreniz en az 5 karakter içermelidir!"),
  passwordConfirmation: Yup.string()
    .required("FORM.REQUIRED")
    .oneOf([Yup.ref("password"), null], "PASSWORD_NOT_MATCH")
    .min(5, "Yeni şifreniz en az 5 karakter içermelidir!")
});

export default function CheckUserPasswordReset() {
  const dispatch = useDispatch();
  const auth = useSelector(getSelectedAuthorization);
  const { id: userId } = useSelector((state) => state?.user);
  const [isLoading, setIsLoading] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [initialValues] = useState({
    oldPassword: "",
    password: "",
    passwordConfirmation: ""
  });

  useEffect(() => {
    if (process.env.NODE_ENV === "production" && auth?.id?.length > 0) {
      getPasswordResetStatusFromApi();
    }
  }, [JSON.stringify(auth?.id)]);

  const getPasswordResetStatusFromApi = () => {
    apiCall({
      service: checkUserPasswordReset,
      onSuccess: (res) => {
        setShowResetModal(res?.data);
      }
    });
  };

  const onSubmit = (values) => {
    setIsLoading(true);
    apiCall({
      service: changeUserOwnPassword,
      serviceParams: {
        oldPassword: values?.oldPassword,
        userId: userId,
        newPassword: values?.password
      },
      onSuccess: (res) => {
        setIsLoading(false);
        if (res.status === "SUCCESS") {
          setShowResetModal(false);
          showToast("PASSWORD_CHANGED", { type: "success" });
        } else if (res.status === "ERROR") {
          showToast(res?.message || "Bir hata oluştu.", { type: "error" });
        }
      },
      onError: (err) => {
        showToast(err.response?.data?.data?.message || "Bir hata oluştu.", { type: "error" });
        setIsLoading(false);
      }
    });
  };

  const handleLogout = () => {
    apiCall({
      service: logout,
      onSuccess: () => {
        dispatch(logoutAction());
        setShowResetModal(false);
      },
      onError: () => {
        showToast("Bir hata oluştu. Lütfen tekrar deneyiniz.", { type: "error" });
      }
    });
  };

  return (
    <Modal show={showResetModal} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={"Şifre Sıfırla"} />
        </Modal.Title>
        <button className="btn btn-secondary" onClick={handleLogout}>
          Vazgeç
        </button>
      </Modal.Header>
      <Formik
        onSubmit={onSubmit}
        validationSchema={passwordValidation}
        initialValues={initialValues}
        enableReinitialize
      >
        <Form>
          <Modal.Body>
            <div className="d-flex flex-column">
              <Field
                name="oldPassword"
                label="COMMON.OLD.PASSWORD"
                component={CustomInput}
                withFeedbackLabel={true}
                type="password"
                placeholder="Mevcut Şifre"
              />
              <Field
                name="password"
                label="COMMON.NEW.PASSWORD"
                component={CustomInput}
                withFeedbackLabel={true}
                type="password"
                placeholder="Yeni Şifre"
              />
              <Field
                name="passwordConfirmation"
                label="AUTH.CONFIRM_PASSWORD"
                component={CustomInput}
                withFeedbackLabel={true}
                type="password"
                placeholder="Şifreyi Onayla"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className={`btn btn-info ${isLoading ? "spinner spinner-white spinner-left" : ""}`}
              disabled={isLoading}
              type="submit"
            >
              Kaydet
            </button>
          </Modal.Footer>
        </Form>
      </Formik>
    </Modal>
  );
}
